import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncUiModule, EmptyStateModule, UIKitModule } from '@vendasta/uikit';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OpportunityQualificationComponent } from './opportunity-qualification.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MeddicModule } from '../../../../meddic/meddic.module';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    TranslateModule,
    MatExpansionModule,
    MatIconModule,
    UIKitModule,
    EmptyStateModule,
    MatButtonToggleModule,
    MatTabsModule,
    RouterModule,
    MatTooltipModule,
    AsyncUiModule,
    MatSelectModule,
    MatDividerModule,
    MatProgressBarModule,
    MeddicModule,
  ],
  declarations: [OpportunityQualificationComponent],
  exports: [OpportunityQualificationComponent],
  providers: [],
})
export class OpportunityQualificationModule {}
